// extracted by mini-css-extract-plugin
export default {"input":"IH6GQ7","wrapper":"IoTl7R","radio":"Ya0rXi","label":"dJPvkh"};